// extracted by mini-css-extract-plugin
export var container = "_61-0";
export var fallback = "_61-5";
export var fallbackIcon = "_61-6";
export var hidden = "_61-2";
export var image = "_61-3";
export var loaded = "_61-4";
export var placeholder = "_61-1";